// @flow
import { logEvent } from 'firebase/analytics';

import { analytics } from '../Services/firebaseApp';
import type { LogFirebaseEvent } from '../Redux/ApplicationActions';

export default function logEventSaga(action: LogFirebaseEvent): void {
  const { eventName } = action;

  logEvent(analytics, eventName);
}
